import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { User } from '../models/user';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cote',
  templateUrl: './cote.component.html',
  styleUrls: ['./cote.component.css']
})
export class CoteComponent implements OnInit {
  private user: User = new User();
  private errorModal: NgbModalRef;
  private errors: string[];

  constructor(private appService: AppService, private modalService: NgbModal) { }

  ngOnInit() {
  }

  openModal() {
    this.errorModal = this.modalService.open(this.appService.errorModal, { size: 'lg'});
  }

  onSubmit() {
    this.appService.getUser(this.user.login).subscribe(userCourant => {
      if (!userCourant || userCourant.id === '-1') {
        this.errors = [];
        this.errors.push('Utilisateur inconnu');
        this.openModal();
      } else {
        this.appService.userCourant = userCourant;
        this.appService.getActu().subscribe(actu =>
          {
            this.appService.actu=actu;
          });
      }
  });
}
}



// WEBPACK FOOTER //
// ./src/app/cote/cote.component.ts